import { DashboardMetrics } from '@/types';
import { getUrl } from '@/utils/api';

interface UseDocumentParams {
  callType: string;
  startDate: string;
  endDate: string;
  refreshInterval: number;
  timezone?: string;
}

function useDocument(
  callType: UseDocumentParams['callType'],
  startDate: UseDocumentParams['startDate'],
  endDate: UseDocumentParams['endDate'],
  refreshInterval: UseDocumentParams['refreshInterval'],
  timezone: UseDocumentParams['timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone,
) {
  const urlParams = new URLSearchParams({
    call_type: callType,
    start_date: startDate,
    end_date: endDate,
    timezone: timezone,
  }).toString();

  const url = `v1/dashboard/metrics?${urlParams}`;

  const query = getUrl(url, {
    refreshInterval: refreshInterval,
  });

  return {
    ...query,
    data: query.data as DashboardMetrics,
  };
}

export default useDocument;
